import { useEffect } from 'react';
import { useLayoutEditorContext } from '../../../../hooks/context/useLayoutEditorContext';
import { focusFormFieldByName } from '../../../../utils/forms/focusFormFieldByName';
import { LayoutContentError } from '../../../../utils/layouts/validateLayoutContent';

type UseSaveErrorFocusOptions = {
  // Opens the panel accordion section the first error lives in.
  onOpenSection: (section: LayoutContentError['scope']) => void;
};

// Failed save validation: open the section of the first error and focus its
// field (saveLayout already selected the offending object). One-shot per
// save — keyed by saveErrorsVersion, the saveErrors array itself changes on
// every edit.
export const useSaveErrorFocus = ({
  onOpenSection,
}: UseSaveErrorFocusOptions): void => {
  const { saveErrors, saveErrorsVersion } = useLayoutEditorContext();

  useEffect(() => {
    if (saveErrorsVersion === 0) {
      return;
    }

    const firstError = saveErrors[0];

    if (!firstError) {
      return;
    }

    onOpenSection(firstError.scope);
    // The focus engine waits until the field renders (accordion opening,
    // object form remount after the selection change).
    focusFormFieldByName(firstError.field, { suppressOpenOnFocus: true });
    // saveErrors/onOpenSection intentionally not dependencies — one-shot per
    // version bump.
  }, [saveErrorsVersion]);
};
